import { render, staticRenderFns } from "./allSurface.vue?vue&type=template&id=7f7fa126&"
import script from "./allSurface.vue?vue&type=script&lang=ts&"
export * from "./allSurface.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports